export interface IDOWN_PAYMENT_FORMULA {
  totalCostOfAsset: number | undefined;
  downPayment: number | undefined;
  rateOfInterest: number | undefined;
  processingFee: number | undefined;
  loanTenure: number | undefined;
}

export const DOWN_PAYMENT_FORMULA = ({
  totalCostOfAsset,
  downPayment,
  rateOfInterest,
  processingFee,
  loanTenure,
}: IDOWN_PAYMENT_FORMULA) => {
  if (
    !totalCostOfAsset ||
    !downPayment ||
    !processingFee ||
    !rateOfInterest ||
    !loanTenure ||
    totalCostOfAsset < 0 ||
    downPayment < 0 ||
    processingFee < 0 ||
    rateOfInterest < 0 ||
    loanTenure < 0
  ) {
    return {
      totalDownPayment: 0,
      loanAmount: 0,
      totalProcessingFee: 0,
      cashNeeded: 0,
      monthlyPayment: 0,
    };
  }

  const totalDownPayment = Number(totalCostOfAsset * (downPayment / 100));
  const loanAmount = totalCostOfAsset - totalDownPayment;
  const totalProcessingFee = Number(loanAmount * (processingFee / 100));

  const cashNeeded = totalDownPayment + totalProcessingFee;
  const monthlyPayment =
    (loanAmount *
      (rateOfInterest / 100 / 12) *
      Math.pow(1 + rateOfInterest / 100 / 12, loanTenure * 12)) /
    (Math.pow(1 + rateOfInterest / 100 / 12, loanTenure * 12) - 1);

  return {
    totalDownPayment,
    loanAmount,
    totalProcessingFee,
    cashNeeded,
    monthlyPayment,
  };
};
